import React, { createContext, useContext, ReactNode } from "react";

interface IndexBarcodesProviderProps {
  children: ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IndexBarcodesContextValue {}

const IndexBarcodesContext = createContext<
  IndexBarcodesContextValue | undefined
>(undefined);

const IndexBarcodesProvider: React.FC<IndexBarcodesProviderProps> = ({
  children,
}) => {
  return (
    <IndexBarcodesContext.Provider value={{}}>
      {children}
    </IndexBarcodesContext.Provider>
  );
};

const useIndexBarcodesContext = (): IndexBarcodesContextValue => {
  const context = useContext(IndexBarcodesContext);
  if (!context) {
    throw new Error(
      "useIndexBarcodesContext must be used within an IndexBarcodesProvider"
    );
  }
  return context;
};

export { IndexBarcodesProvider, useIndexBarcodesContext };
